/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Processes_LinkInputs */

const en_faq_processes_link = /** @type {(inputs: Faq_Processes_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See six everyday examples.`)
};

const lv_faq_processes_link = /** @type {(inputs: Faq_Processes_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apskatīt sešus ikdienas piemērus`)
};

/**
* | output |
* | --- |
* | "See six everyday examples." |
*
* @param {Faq_Processes_LinkInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_processes_link = /** @type {((inputs?: Faq_Processes_LinkInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Processes_LinkInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_processes_link(inputs)
	return en_faq_processes_link(inputs)
});